import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import { Slide, ToastContainer, toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { studentCertificatesManagement } from "../../../../../../hooks/api/StudentCertificatesManagement/StudentCertificatesManagement";
import { getNumberOfUsedFilters } from "../../../../../../services/utils/Filter";
import { DefaultLayout } from "../../../../../../layouts/Default";
import { TopNavigation } from "../../../../../../themes/Default/components/TopNavigation";
import { Button, ButtonBack } from "../../../../../../themes/Default/components/TopNavigation/components/Button";
import { Tabs } from "../../../../../../themes/Default/components/Tabs";
import { Main } from "../../../../../../themes/Default/components/Main";
import { Title } from "../../../../../../themes/Default/components/Title";
import { Title as ListTitle } from "../../../../../../themes/Default/components/List/components/Header/components/Title";
import { Breadcrumps } from "../../../../../../themes/Default/components/Breadcrumps";
import { Link } from "../../../../../../themes/Default/components/Breadcrumps/components/Link";
import { List } from "../../../../../../themes/Default/components/List";
import { Menu as ListMenu } from "../../../../../../themes/Default/components/List/components/Header/components/Menu";
import { Body as ListBody } from "../../../../../../themes/Default/components/List/components/Body";
import { Header as ListHeader } from "../../../../../../themes/Default/components/List/components/Header";
import { Filter as ListFilter } from "../../../../../../themes/Default/components/List/components/Header/components/Filter";
import { Button as ListMenuButton } from "../../../../../../themes/Default/components/List/components/Header/components/Menu/components/Button";
import { Form } from "../../../../../../themes/Default/components/Form";
import { Row } from "../../../../../../themes/Default/components/Form/components/Row";
import { Field } from "../../../../../../themes/Default/components/Form/components/Row/components/Field";
import { Input } from "../../../../../../themes/Default/components/Form/components/Input";
import { TableHead } from "../../../../../../themes/Default/components/List/components/Body/components/TableHead";
import { TableRow } from "../../../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow";
import { TableHeadCell } from "../../../../../../themes/Default/components/List/components/Body/components/TableHead/components/TableRow/components/TableHeadCell";
import { TableBody } from "../../../../../../themes/Default/components/List/components/Body/components/TableBody";
import { TableDataCell } from "../../../../../../themes/Default/components/List/components/Body/components/TableBody/components/TableDataCell";
import { Checkbox } from "../../../../../../themes/Default/components/Form/components/Checkbox";
import { Pagination } from "../../../../../../themes/Default/components/List/components/Footer/components/Pagination";
import Toaster from "../../../../../../themes/Default/components/Toaster/Toaster";

const Certificates = () => {
    const { t } = useTranslation("common");
    const recordsPerPage = 100;
    const defaultFilters = {
        startPage: 0,
        limitPage: recordsPerPage,
    };
    const formRef = useRef(null);
    const navigate = useNavigate();
    const [filters, setFilters] = useState(defaultFilters);
    const [showFilter, setShowFilter] = useState(false);
    const [numberOfUserdFilters, setNumberOfUserdFilters] = useState();
    const [totalRecords, setTotalRecords] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [disableDelete, setDisableDelete] = useState(true);
    const [selectedCertificate, setSelectedCertificate] = useState([]);
    const [certificates, setCertificates] = useState();
    const { useStudentCertificateListMutation, useDeleteStudentCertificateMutation } = studentCertificatesManagement;
    const [certificateList, { isLoading }] = useStudentCertificateListMutation();
    const [deleteCertificate] = useDeleteStudentCertificateMutation();

    const tabs = [
        { title: t("schools.title"), onClick: () => gotoSchoolTab() },
        { title: t("certificates.title"), isActive: true },
        { title: t("address.title"), onClick: () => gotoAddressTab()},
    ];

    const gotoSchoolTab = () => {
        navigate("/settings/students/schools");
    };

    const gotoAddressTab = () => {
        navigate("/settings/students/address");
    };

    const openFilter = () => {
        setShowFilter(true);
    };

    const closeFilter = () => {
        setShowFilter(false);
    };

    const gotoNew = () => {
        navigate("/settings/students/certificates/add");
    };

    const gotoEdit = (certificateId) => {
        navigate("/settings/students/certificates/edit/" + certificateId);
    };

    const onFilter = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    };

    const onFiltered = (values) => {
        setFilters({
            ...filters,
            startPage: 0,
            name: values.name,
        });
    };

    const onResetFilter = () => {
        setFilters(defaultFilters);
        setShowFilter(false);
        if (formRef.current) {
            formRef.current.resetForm();
        }
    };

    const onPageChange = (currentPage) => {
        setCurrentPage(currentPage);
        const newStartPage = (currentPage - 1) * recordsPerPage;
        setFilters({
            ...filters,
            startPage: newStartPage,
            limitPage: recordsPerPage,
        });
    };

    const onSelectionChange = (id) => {
        setSelectedCertificate((prevSelected) => {
            if (prevSelected.includes(id)) {
                return prevSelected.filter((recordId) => recordId !== id);
            } else {
                return [...prevSelected, id];
            }
        });
    };

    const onDelete = () => {
        toast.warn(
            ({ closeToast }) => (
                <Toaster
                    closeToast={closeToast}
                    description={t("areYouSure")}
                    optionNo={t("no")}
                    optionYes={t("yes")}
                    onClick={() => {
                        closeToast();
                        for (let i = 0; i < selectedCertificate?.length; i++) {
                            const certificateId = selectedCertificate[i];
                            deleteCertificate(certificateId).then((result) => {
                                if (result?.error) {
                                    toast.error(result.error.data.error.responseMessage);
                                } else {
                                    certificateList(filters).then((result) => {
                                        const Certificates = result?.data?.records;
                                        setCertificates(Certificates);
                                        setTotalRecords(result?.data?.totalRecords);
                                    });
                                    setDisableDelete(true);
                                    console.log(result);
                                    toast.info(result?.data?.info?.responseMessage);
                                    onSelectionChange(certificateId);
                                }
                            });
                        }
                    }}
                />
            ),
            {
                autoClose: false,
                progress: false,
                closeButton: false,
            },
        );
    };

    useEffect(() => {
        if (selectedCertificate.length > 0) {
            setDisableDelete(false);
        } else {
            setDisableDelete(true);
        }
    }, [selectedCertificate]);

    useEffect(() => {
        certificateList(filters).then((result) => {
            const certificates = result?.data?.records;
            setCertificates(certificates);
            setTotalRecords(result?.data?.totalRecords);
        });
        setNumberOfUserdFilters(getNumberOfUsedFilters(filters));
    }, [filters, certificateList]);

    return (
        <DefaultLayout>
            
            <TopNavigation>
                <ButtonBack to="/settings" />
                <Button title={t("certificates.addNew")} icon="fa-regular fa-plus" onClick={gotoNew}></Button>
                <Button title={t("delete")} icon="fa-regular fa-trash-can" isDisabled={disableDelete} onClick={onDelete}></Button>
            </TopNavigation>
            <Tabs tabs={tabs} />
            <Main>
                <Title>{`${t("certificates.title")} (${totalRecords})`}</Title>
                <Breadcrumps>
                    <Link title={t("settings.title")} icon="fa-gear" />
                    <Link title={t("students.title")} />
                    <Link title={t("certificates.title")} />
                    <Link title={t("settings.list")} isActive={true} />
                </Breadcrumps>
                {!isLoading && (
                    <>
                        <List>
                            <ListHeader>
                                <ListMenu>
                                    <ListMenuButton title="Filter" icon="fa-filter" onClick={openFilter} badge={numberOfUserdFilters} />
                                </ListMenu>
                                <ListFilter isVisible={showFilter} onClose={closeFilter} onFilter={onFilter} onResetFilter={onResetFilter}>
                                    <Formik
                                        innerRef={formRef}
                                        initialValues={{
                                            name: filters?.name,
                                        }}
                                        onSubmit={onFiltered}
                                    >
                                        {({ values, handleChange, handleSubmit, resetForm }) => (
                                            <Form>
                                                <Row>
                                                    <Field>
                                                        <Input name="name" label={t("certificates.name")} value={values.name} onChange={handleChange} />
                                                    </Field>
                                                </Row>
                                            </Form>
                                        )}
                                    </Formik>
                                </ListFilter>
                            </ListHeader>
                            <ListBody>
                                <TableHead>
                                    <TableRow>
                                        <TableHeadCell></TableHeadCell>
                                        <TableHeadCell></TableHeadCell>
                                        <TableHeadCell>
                                            <span>{t("certificates.name")}</span>
                                        </TableHeadCell>
                                        <TableHeadCell></TableHeadCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {certificates?.length > 0 &&
                                        certificates?.map((certificate, index) => {
                                            return (
                                                <TableRow key={certificate.id}>
                                                    <TableDataCell>
                                                        <Button icon="fa-regular fa-pen" onClick={() => gotoEdit(certificate.id)}></Button>
                                                    </TableDataCell>
                                                    <TableDataCell>
                                                        <Checkbox
                                                            name="isBlockClass"
                                                            value={certificate.id}
                                                            onChange={() => onSelectionChange(certificate.id)}
                                                        />
                                                    </TableDataCell>
                                                    <TableDataCell>{certificate.name}</TableDataCell>
                                                    <TableDataCell></TableDataCell>
                                                </TableRow>
                                            );
                                        })}
                                </TableBody>
                            </ListBody>
                        </List>
                        <Pagination currentPage={currentPage} recordsPerPage={recordsPerPage} totalRecords={totalRecords} onClick={onPageChange} />
                    </>
                )}
            </Main>
        </DefaultLayout>
    );
};

export default Certificates;
